module.exports = __webpack_public_path__ + "img/homepage.b496fd1.jpg";